import { useEffect, useState } from "react";

type AuditRow = {
  id: string;
  siteId: string | null;
  actorUserId: string | null;
  action: string;
  details: Record<string, unknown>;
  createdAt: string;
};

export default function Audit() {
  const [rows, setRows] = useState<AuditRow[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    fetch(`/api/admin/audit`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : Promise.reject(r.statusText)))
      .then((data: { rows: AuditRow[] }) => setRows(data.rows))
      .catch((e) => setErr(String(e)));
  }, []);

  return (
    <div className="stack">
      <h1 style={{ margin: 0 }}>Audit log</h1>
      {err && <div className="card" style={{ borderColor: "#fee2e2" }}>{err}</div>}
      {!rows && <div className="muted">Loading…</div>}
      {rows && rows.length === 0 && <div className="muted">No actions yet.</div>}
      {rows?.map((r) => (
        <div key={r.id} className="card row between">
          <div>
            <strong>{r.action}</strong>
            <div className="muted" style={{ fontSize: 12 }}>
              {r.actorUserId ? `actor ${r.actorUserId.slice(0, 8)}…` : "no actor"}
              {r.siteId ? ` · site ${r.siteId.slice(0, 8)}…` : ""}
            </div>
          </div>
          <span className="muted" style={{ fontSize: 12 }}>{new Date(r.createdAt).toLocaleString()}</span>
        </div>
      ))}
    </div>
  );
}
